import styled from "styled-components";

export const DropdownContainer = styled.div`
  width: 100%;
  position: relative;
  z-index: 3;
`;

export const DropdownButton = styled.button<{ isOpen: boolean; isEmpty: boolean }>`
  font-family: "Arial", sans-serif;
  width: 100%;
  height: 3rem;
  padding: 0.5rem 1.5rem;
  border: 2px solid ${(props) => (props.isOpen ? "#2196F3" : "#ddd")};
  background-color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  font-weight: 300;
  color: ${(props) => (props.isEmpty ? "#898888ff" : "#333")};
  transition: all 0.2s ease;
  z-index: 9999999;

  &:hover {
    border-color: #2196f3;
  }

  .arrow {
    font-size: 20px;
    transition: transform 0.2s ease;
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

export const DropdownMenu = styled.div`
  background-color: #fff;
  border: 2px solid #2196f3;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 15rem;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #2196f3;
    border-radius: 2px;

    &:hover {
      background: #1976d2;
    }
  }
`;

export const DropdownItem = styled.div<{ isSelected: boolean }>`
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${(props) => (props.isSelected ? "#E3F2FD" : "#fff")};
  color: ${(props) => (props.isSelected ? "#2196F3" : "#333")};
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: ${(props) => (props.isSelected ? "600" : "500")};
  transition: background-color 0.15s ease, color 0.15s ease;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  span {
    flex: 1;
  }

  &:hover,
  &[data-focused="true"] {
    background-color: ${(props) => (props.isSelected ? "#BBDEFB" : "#f5f5f5")};
  }

  &[data-focused="true"] {
    background-color: ${(props) => (props.isSelected ? "#BBDEFB" : "#E3F2FD")};
    color: ${(props) => (props.isSelected ? "#2196F3" : "#1976D2")};
    outline: none;
  }
`;

export const ErrorMessage = styled.span`
  color: #f44336;
  font-size: 14px;
  margin-top: 8px;
  display: block;
`;